import React, { useState, useEffect } from 'react';
import { AboutProvider } from './hooks/useAbout';
import MatrixRain from './components/MatrixRain';
import Navbar     from './components/Navbar';
import Hero       from './components/Hero';
import About      from './components/About';
import Skills     from './components/Skills';
import Experience from './components/Experience';
import Projects   from './components/Projects';
import Education  from './components/Education';
import Certificates from './components/Certificates';
import Research   from './components/Research';
import Conferences from './components/Conferences';
import Hackathons from './components/Hackathons';
import Blog       from './components/Blog';
import Contact    from './components/Contact';
import Footer     from './components/Footer';
import './App.scss';

function App() {
  const [theme, setTheme] = useState(() => {
    try { return localStorage.getItem('theme') || 'dark'; }
    catch { return 'dark'; }
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    try { localStorage.setItem('theme', theme); } catch {}
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <AboutProvider>
      <div className="app">
        <MatrixRain theme={theme} />
        <Navbar theme={theme} toggleTheme={toggleTheme} />
        <main>
          <Hero />
          <About />
          <Skills />
          <Experience />
          <Projects />
          <Education />
          <Certificates />
          <Research />
          <Conferences />
          <Hackathons />
          <Blog />
          <Contact />
        </main>
        <Footer />
      </div>
    </AboutProvider>
  );
}

export default App;
